module.exports = __webpack_public_path__ + "media/images/fb_ico-82f683e0abcceae987308c5c1839d43f.png";